import { getNavigationAutos } from './getNavigationAutos';
import { getLocationsHistory } from './getLocationsHistory';
import { resetLocationsHistory } from './resetLocationsHistory';

export const navigationOperations = {
  getNavigationAutos,
  getLocationsHistory,
  resetLocationsHistory
};
